/* global o_tracking */

window.o_global = window.o_global || {};

/**
 * M-Pathy API-JS File. Here you can find functions for M-Pathy to deal with OTTO-Features.
 */
o_global.mpathy = o_global.mpathy || (function (win) {
  "use strict";

  /**
   * Tracking API for M-Pathy. (@see https://jira.scm.otto.de/browse/ASSETS-210)
   *
   * @param {Object}  options
   * @param {String}  options.vistorId    M-Pathy VisitorID.
   * @param {Boolean} options.tracking    Indicator if M-Pathy tracking was enabled.
   * @param {String}  [options.surveyId]  Active M-Pathy survey.
   *
   * @returns {undefined}
   */
  function track(options = {}) {
    const visitorId = options.visitorId;
    const tracking = options.tracking;

    if (typeof visitorId === "string" && typeof tracking === "boolean") {
      const surveyId = options.surveyId;
      const trackingData = {
        ot_MpathyVid: visitorId,
        ot_MpathyTracking: tracking
      };

      if (surveyId) {
        trackingData.ot_SurveyId = surveyId;
      }

      if (window.o_global.eventQBus) {
        window.o_global.eventQBus.emit("tracking.bct.addToPageImpression", trackingData)
      }
    }
  }

  /**
   * Check if mPathy should be enabled.
   * Extend the tests array to add new tests.
   *
   * @example in shopoffice: if (mpathySwitch === 'on' && o_global.mpathy.isEnabled())
   *
   * @return {Boolean} Returns true if ONE of the tests returns TRUE and _isDisabled() is false.
   */
  function isEnabled() {
    // Array with test functions.
    var tests = [
      _isBreakpointGreaterThanM,
      _deviceTest
    ];

    if (!o_util.toggle.get("EMR_MPATHY", true) || o_util.misc.isPreview(win.location.href)) {
      return false;
    }

    if (_isPrivacyPage()) {
      return false;
    }

    return _runTests(true, tests);
  }

  /**
   * Check if visited page is privacy page (/shoppages/service/datenschutz)
   *
   * @return {Boolean} is privacy page
   *
   * @private
   */
  function _isPrivacyPage() {
    // Must use 'indexOf' because Firefox before 53 returned wrong parts of the url as the pathname.
    return win.location.pathname.indexOf("/shoppages/service/datenschutz") !== -1;
  }

  /**
   * Run the tests for isEnabled()
   *
   * @private
   *
   * @param {Boolean} result      To return true/false on first true/false test.
   * @param {Array} tests         Functions to run.
   *
   * @return {Boolean} Result if its first test or not
   */
  function _runTests(result, tests) {
    while (tests.length) {
      if (tests.shift().call() === result) {
        return result;
      }
    }

    return !result;
  }

  /**
   * Check for breakpoint > M in cookie.
   *
   * @private
   *
   * @return {Boolean} Value if breakpoint is greater than M
   */
  function _isBreakpointGreaterThanM() {
    return o_global.device.breakpoint.getCurrentBreakpoint() !== "s" && o_global.device.breakpoint.getCurrentBreakpoint() !== "m";
  }

  /**
   * Check if the client is visiting the page with a specific device.
   *
   * @private
   *
   * @return {Boolean} Value if the user uses a specific device
   */
  function _deviceTest() {
    /**
     * Check the user agent to detect Galaxy S5, S5 mini, S6, S6 Edge, S7.
     *
     * @see http://user-agents.me/device/samsung-galaxy-s5
     *
     * @private
     *
     * @return {Boolean} Value if device is strong Samsung Galaxy
     */
    function _isStrongSamsungGalaxy() {
      var models = [
        "SAMSUNG SM-G900F",     // S5
        "SM-G900P",             // S5
        "SAMSUNG SM-G900H",     // S5
        "SAMSUNG SM-G900T",     // S5
        "SM-G900F",             // S5
        "SM-G900H",             // S5
        "SCL23",                // S5
        "SAMSUNG SM-G900FQ",    // S5
        "SM-G900T",             // S5
        "SM-G900V",             // S5
        "SM-G900M",             // S5
        "SC-04F",               // S5
        "SAMSUNG SM-G900I",     // S5
        "SM-G920F",             // S6
        "SM-G920I",             // S6
        "SM-G9200",             // S6
        "SM-G925F",             // S6 Edge
        "SM-G800F",             // S5 mini
        "SM-G930F"              // S7
      ];

      for (var i in models) {
        if (models.hasOwnProperty(i) && !!navigator.userAgent.match(models[i])) {
          return true;
        }
      }

      return false;
    }

    /**
     * Check the user agent for "iPhone" and the screen size to detect the iPhone 6.
     * Unfortunately there is no other way to detect the iPhone model/version.
     *
     * @private
     *
     * @return {Boolean} Value if device is iphone 6
     */
    function _isIPhone6() {
      return !!navigator.userAgent.match("iPhone") && ((window.screen.height === 667 && window.screen.width === 375) || (window.screen.width === 667 && window.screen.height === 375));
    }

    return (_isStrongSamsungGalaxy() || _isIPhone6()) && _connectionTypeTest();
  }

  /**
   * Check for the experimental navigator.connection.type feature.
   * Return false if available and the user is not in the wifi.
   *
   * @private
   *
   * @return {Boolean} Value if the test could be ran or not
   */
  function _connectionTypeTest() {
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;

    // Connection api not supported: pass the test
    if (!connection) {
      return true;
    }

    // Pass only if user connected to wifi or '2' in case of Galaxy S5 with stockbrowser
    return (connection.type === "wifi") || (parseInt(connection.type, 10) === 2);
  }

  return {
    track,
    isEnabled
  };
}(window));
